module.exports = __webpack_public_path__ + "img/shield-lock-fill.9f038623.svg";